import type { TOC } from '@ember/component/template-only';
import { PrismBreadcrumb, PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { not, or } from 'ember-truth-helpers';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import SettingsPropertyTagsTablePropertyTags from 'lumen/components/settings/property-tags/table-property-tags';
import type MarketSettingsPropertyTagsOrganizeController from 'lumen/controllers/market/settings/property-tags/organize';
import hasFeatureToggle from 'lumen/helpers/has-feature-toggle';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';

interface MarketSettingsPropertyTagsOrganizeSignature {
  Args: {
    controller: MarketSettingsPropertyTagsOrganizeController;
    model: unknown;
  };
}

<template>
  <SettingsPageTemplate
    @description={{if
      (hasFeatureToggle FEATURE_TOGGLES.CUSTOM_PROPERTY_TAGS)
      (t "settings.property_tags.organize_hotels.description")
      (t "settings.property_tags.description")
    }}
    @isFullHeight={{true}}
    @title={{if
      (hasFeatureToggle FEATURE_TOGGLES.CUSTOM_PROPERTY_TAGS)
      (t "settings.property_tags.organize_hotels.title")
      (t "settings.property_tags.title")
    }}
  >
    <:breadcrumb>
      {{#if (hasFeatureToggle FEATURE_TOGGLES.CUSTOM_PROPERTY_TAGS)}}
        <PrismBreadcrumb as |B|>
          <B.item
            @label={{t "settings.property_tags.title"}}
            @route="market.settings.property-tags.index"
          />
          <B.item
            @isCurrent={{true}}
            @label={{t "settings.property_tags.organize_hotels.title"}}
          />
        </PrismBreadcrumb>
      {{/if}}
    </:breadcrumb>
    <:headerAfter>
      <div class="flex gap-200">
        <PrismButton
          @buttonType="secondary"
          @isDisabled={{or
            (not @controller.hasUnsavedChanges)
            @controller.saveChangesTask.isRunning
          }}
          @label={{t "general.cancel"}}
          @onClick={{@controller.cancelChanges}}
          data-test-id="button-cancel"
        />
        <PrismButton
          @isDisabled={{or
            (not @controller.hasUnsavedChanges)
            @controller.saveChangesTask.isRunning
          }}
          @isLoading={{@controller.saveChangesTask.isRunning}}
          @label={{t "general.save"}}
          @onClick={{@controller.saveChangesTask.perform}}
          data-test-id="button-save"
        />
      </div>
    </:headerAfter>
    <:default>
      <SettingsPropertyTagsTablePropertyTags
        @isLoading={{@controller.model.propertyTags.isRunning}}
        @propertyTags={{@controller.propertyTags}}
      />
    </:default>
  </SettingsPageTemplate>
</template> satisfies TOC<MarketSettingsPropertyTagsOrganizeSignature>;
